/**
 * India VIX service — talks to `/api/v1/india-vix/*` (see
 * `app.api.v1.india_vix`). Separate from `optionsDashboardService` because
 * these routes aren't scoped to a symbol (VIX is market-wide) and have
 * their own admin-only mutation (`sync`), even though the "current" value
 * is displayed on the same Options Dashboard page.
 */

import api from "@/services/api";
import type {
  IndiaVixCurrentRead,
  IndiaVixHistoryResponse,
  IndiaVixSyncRequest,
  IndiaVixSyncResponse,
} from "@/types";

export interface VixHistoryParams {
  from_date?: string;
  to_date?: string;
}

export const indiaVixService = {
  async getCurrent(): Promise<IndiaVixCurrentRead> {
    const { data } = await api.get<IndiaVixCurrentRead>("/india-vix/current");
    return data;
  },

  async getHistory(params: VixHistoryParams = {}): Promise<IndiaVixHistoryResponse> {
    const { data } = await api.get<IndiaVixHistoryResponse>("/india-vix/history", { params });
    return data;
  },

  /** Admin-only (backend enforces `require_roles("ADMIN")`). */
  async sync(body: IndiaVixSyncRequest): Promise<IndiaVixSyncResponse> {
    const { data } = await api.post<IndiaVixSyncResponse>("/india-vix/sync", body);
    return data;
  },
};

export default indiaVixService;
